export const getHHMMSS = (secs) => {
  const secNum = parseInt(secs, 10)
  const hours = Math.floor(secNum / 3600)
  const minutes = Math.floor(secNum / 60) % 60
  const seconds = secNum % 60

  return [hours, minutes, seconds]
    .map(v => v < 10 ? '0' + v : v)
    .filter((v, i) => v !== '00' || i > 0)
    .join(':')
}

const formatCountdownSegment = countdownSegment => {
  if (countdownSegment < 10) {
    return `0${countdownSegment}`
  }

  return countdownSegment
}

export const getTimeRemaining = (deadlineISOString) => {
  const dateNow = new Date()
  const dateDeadline = new Date(deadlineISOString)

  if (dateNow > dateDeadline) {
    return false
  }

  let delta = Math.abs(dateDeadline - dateNow) / 1000
  const days = Math.floor(delta / 86400)
  delta -= days * 86400

  const hours = Math.floor(delta / 3600) % 24
  delta -= hours * 3600

  const minutes = Math.floor(delta / 60) % 60
  delta -= minutes * 60

  const seconds = Math.floor(delta % 60)

  return {
    days: formatCountdownSegment(days),
    hours: formatCountdownSegment(hours),
    minutes: formatCountdownSegment(minutes),
    seconds: formatCountdownSegment(seconds)
  }
}

export const getFriendlyDateTime = (timestamp, hasTimezone) => {
  const date = new Date(timestamp)

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }

  if (hasTimezone) {
    options.timeZoneName = 'short'
  }

  const friendlyDate = date.toLocaleDateString('en-US', options)

  const friendlyTime = date.toLocaleTimeString('en-US')

  return `${friendlyDate} ${friendlyTime}`
}
